import { createAction } from '@reduxjs/toolkit';
import type { UseToastOptions } from '@chakra-ui/react';

import { SHOW_TOAST } from './index';

export const showToast = createAction(SHOW_TOAST, (payload: UseToastOptions) => {
  return { payload };
});
